import React from "react";
import Header from "./header";
import EventCard from "./EventCard";
import EventDetailTabs from "./EventDetailTabs";
import ContentContainerTab from "./ContentContainerTab";
import { useParams } from "react-router-dom";
import { useEventDetails } from "../../api/event/queryHooks";
import { decodeId } from "../../api/utils";

function EventPage() {
  const id = decodeId(useParams()?.id);
  const { isError } = useEventDetails(id);

  if (isError) return <div>Not Found</div>;

  return (
    <>
      <Header />
      <EventCard />
      <EventDetailTabs />
      <ContentContainerTab />
    </>
  );
}

export default EventPage;
